import HorizontalChart from "./HorizontalChart"

export default HorizontalChart
